"use strict";
/**
 * @author tatevik.marikyan
 * @since 29/07/2018
 */
Object.defineProperty(exports, "__esModule", { value: true });
var HierarchicalSearchFilterOptions = /** @class */ (function () {
    function HierarchicalSearchFilterOptions(query, categories, languageId, level) {
        this.query = query;
        this.categories = categories;
        this.languageId = languageId;
        this.level = level;
    }
    return HierarchicalSearchFilterOptions;
}());
exports.HierarchicalSearchFilterOptions = HierarchicalSearchFilterOptions;
//# sourceMappingURL=hierarchical-search-filter-options.model.js.map